import { useState, useRef } from 'react';
import './CsvImportModal.css';
import { apiFetch } from '../api';

export default function CsvImportModal({
  open,
  title = 'Import CSV',
  onClose,
  onImport,
  loading = false,
  accept = '.csv',
}) {
  const [dragging, setDragging] = useState(false);
  const fileInputRef = useRef(null);

  if (!open) return null;

  const handleFile = file => {
    if (!file) return;
    onImport(file);
  };

  const handleDrop = e => {
    e.preventDefault();
    setDragging(false);
    handleFile(e.dataTransfer.files[0]);
  };

  return (
    <div className="csv-modal-backdrop">
      <div className="csv-modal">
        <h2>{title}</h2>
        <div
          className={`csv-dropzone ${dragging ? 'dragging' : ''}`}
          onDragOver={e => {
            e.preventDefault();
            setDragging(true);
          }}
          onDragLeave={() => setDragging(false)}
          onDrop={handleDrop}
          onClick={() => fileInputRef.current.click()}
        >
          <p>Drag & drop CSV file here</p>
          <span>or click to browse</span>

          <input
            ref={fileInputRef}
            type="file"
            accept={accept}
            hidden
            onChange={e => handleFile(e.target.files[0])}
          />
        </div>
        <div className="csv-modal-actions">
          <button className="btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button className="btn-primary" disabled>
            {loading ? 'Importing...' : 'Waiting for file'}
          </button>
        </div>
        <div>
        <p>
            To download sample file please click{' '}
            <a
            href="import/item_master.csv"
            download
            style={{ color: '#2563eb', fontWeight: 600 }}
            >
            here
            </a>
        </p>
        </div>
      </div>
    </div>
  );
}
